import styled, { keyframes } from 'styled-components';

import { ANIMATION_DURATION } from './config';

const animateMount = keyframes`
  from {
    transform: translateY(5rem);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const animateUnmount = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(5rem);
    opacity: 0;
  }
`;

export const AnimateMountUnmount = styled.div<{
  unmounting: boolean;
  delay?: number;
}>`
  transform: translateY(5rem);
  opacity: 0;

  animation: ${({ unmounting }) => (unmounting ? animateUnmount : animateMount)}
    ${({ unmounting }) =>
      unmounting
        ? `${ANIMATION_DURATION.unmount}ms`
        : `${ANIMATION_DURATION.mount}ms`}
    ease-out forwards;

  animation-delay: ${({ delay = 0, unmounting }) => (unmounting ? 0 : delay)}ms;
`;
